import _ from "lodash";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { Table } from "semantic-ui-react";

class StandingsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      column: null,
      standingsList: props.simulationStandings,
      direction: null,
    };
  }

  handleSort = (clickedColumn) => () => {
    const { column, standingsList, direction } = this.state;
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        standingsList: _.sortBy(standingsList, [clickedColumn]),
        direction: "ascending",
      });
      return;
    }
    this.setState({
      standingsList: standingsList.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  };

  render() {
    const translate = this.props.translate;
    const { column, direction, standingsList } = this.state;
    const arrowsIcon = <FontAwesomeIcon className="tableIcon" icon={faSort} size="lg" color="#FFF" />;
    return (
      <div className="tableContainer" ref={(ref) => (this.topTable = ref)}>
        <p>{`${translate("totalTeams")}: ${standingsList.length}`}</p>
        <Table unstackable sortable selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === "position" ? direction : null} onClick={this.handleSort("position")}>
                <div className="headerCell">
                  {translate("standings").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "name" ? direction : null} onClick={this.handleSort("name")}>
                <div className="headerCell">
                  {translate("Common:team").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "step" ? direction : null} onClick={this.handleSort("step")}>
                <div className="headerCell">
                  {translate("year").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "gdp" ? direction : null} onClick={this.handleSort("gdp")}>
                <div className="headerCell">
                  {translate("gdp").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "spi" ? direction : null} onClick={this.handleSort("spi")}>
                <div className="headerCell">
                  {"SPI"}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "cash" ? direction : null} onClick={this.handleSort("cash")}>
                <div className="headerCell">
                  {translate("cash").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === "score" ? direction : null} onClick={this.handleSort("score")}>
                <div className="headerCell">
                  {translate("score").toUpperCase()}
                  {arrowsIcon}
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {standingsList.map((standing) => {
              let calculatedScore = standing.score * 100;
              if (calculatedScore < 100) {
                calculatedScore = calculatedScore.toFixed(2);
              }
              return (
                <Table.Row key={standing.position}>
                  <Table.Cell singleLine>{standing.position}</Table.Cell>
                  <Table.Cell singleLine>{standing.name}</Table.Cell>
                  <Table.Cell singleLine>{standing.step}</Table.Cell>
                  <Table.Cell singleLine>{standing.gdp}</Table.Cell>
                  <Table.Cell singleLine>{standing.spi}</Table.Cell>
                  <Table.Cell singleLine>{`$ ${standing.cash}`}</Table.Cell>
                  <Table.Cell singleLine>{calculatedScore}</Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default StandingsComponent;
